export default __webpack_public_path__ + "static/media/ml.bca9c5fc.png";